import React from 'react';
import styled from 'styled-components';
import MediaQuery from "react-responsive";

import { CalendarCell } from './CalendarCells';
import { WEEK_DAYS } from '../../../shared/constants';
import Icon from '../../UI/Icon/Icon';
import './WeekDays.css';

const WeekDaysWrapper = styled.div`
  background-color: #eeeeee;
  display: grid;
   grid-template: repeat(7, auto) / repeat(7, auto);
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  color: #606973;
  padding: 0 10px;    /* -----to be changed  (0 38px)-----*/   
  @media(min-width: 800px) {
    grid-template: repeat(9, auto) / repeat(9, auto);
    font-size: 14px;    
    padding: 0;
  }
`;

const WeekDays = (props) => {
  return (
    <WeekDaysWrapper className="week-names">
      <MediaQuery query="(max-device-width: 768px)">
        <Icon icon="calendar-prev-week-icon" className="date-previous-arrow" onClick={props.handlePreviousWeek} />
        {Object.keys(WEEK_DAYS).map((day, index) => {
          const daylabel = WEEK_DAYS[day];
          return (
            <CalendarCell key={daylabel} index={index} className="week-day-name">
              {daylabel}
            </CalendarCell>
          )
        })}
        <Icon icon="calendar-next-week-icon" className="date-next-arrow" onClick={props.handleNextWeek} />
      </MediaQuery>
      <MediaQuery query="(min-device-width: 769px)">
        {/* <CalendarCell key={55} index={0}>
          {''}
        </CalendarCell> */}
        {Object.keys(WEEK_DAYS).map((day, index) => {
          const daylabel = WEEK_DAYS[day];
          return (
            <CalendarCell key={daylabel} index={index + 1} className="week-day-name">
              {daylabel}
            </CalendarCell>
          )
        })}
        {/* <CalendarCell key={56} index={8}>
          {''}
        </CalendarCell> */}
      </MediaQuery>
    </WeekDaysWrapper>
  );
}

export { WeekDays, WeekDaysWrapper };


// WEBPACK FOOTER //
// ./src/components/UI/DateSelector/WeekDays.js